/**
 * Unsaved Changes Modal
 * POV-0044: Implement unsaved-changes protection
 * 
 * Confirmation dialog shown when user tries to close drawer with unsaved changes.
 */
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '../ui/button';

const UnsavedChangesModal = ({
  isOpen,
  onDiscard,
  onContinueEditing,
}) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Modal Overlay */}
      <div 
        className="fixed inset-0 bg-black/50 z-[60] transition-opacity"
        onClick={onContinueEditing}
        data-testid="unsaved-modal-overlay"
      />
      
      {/* Modal Dialog */}
      <div 
        className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[70] w-full max-w-md"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="unsaved-modal-title"
        aria-describedby="unsaved-modal-description"
        data-testid="unsaved-changes-modal"
      >
        <div className="bg-white rounded-xl shadow-2xl p-6">
          {/* Warning Icon */}
          <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 bg-amber-100 rounded-full">
            <AlertTriangle className="w-6 h-6 text-amber-600" />
          </div>

          {/* Title */}
          <h2 
            id="unsaved-modal-title"
            className="text-lg font-semibold text-slate-900 text-center mb-2"
          >
            Unsaved Changes
          </h2>

          {/* Description */}
          <p 
            id="unsaved-modal-description"
            className="text-sm text-slate-600 text-center mb-6"
          >
            You have unsaved changes that will be lost if you close this panel.
            Would you like to continue editing or discard your changes?
          </p>

          {/* Actions */}
          <div className="flex gap-3">
            <Button
              variant="outline"
              className="flex-1"
              onClick={onDiscard}
              data-testid="discard-changes-button"
            >
              Discard Changes
            </Button>
            <Button
              className="flex-1 bg-haden-primary hover:bg-haden-primary/90"
              onClick={onContinueEditing}
              data-testid="continue-editing-button"
            >
              Continue Editing
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default UnsavedChangesModal;
